// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d50d45b0","453":"6b0d0121","667":"539e42c2"}[chunkId] + ".chunk.js";
};